import React from 'react'

import cn from '~/lib/cn'
import Icon from '~/truck/icon'
import Overlay from '~/truck/overlay'
import type { IProduct } from '~/types/products'

import { VariantsStockTable } from './variants-stock-table'

interface VariantsStockModalProps {
  variants: IProduct[]
  activeVariant?: IProduct
  onClose: () => void
}

// FIXME: use a shared modal!
function VariantsStockModal({ variants, activeVariant, onClose }: VariantsStockModalProps) {
  return (
    <Overlay open blocking onClick={onClose}>
      <div
        className={cn(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
          'flex max-h-[85vh] w-[calc(100vw-2rem)] max-w-lg flex-col',
          'gap-3 rounded-lg bg-white p-4 shadow-xl',
        )}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between">
          <span className="font-semibold">Stock por variante</span>
          <button type="button" onClick={onClose} className="cursor-pointer">
            <Icon type="close" size="sm" color="grayscale80" />
          </button>
        </div>
        <VariantsStockTable variants={variants} activeVariant={activeVariant} />
      </div>
    </Overlay>
  )
}

export default VariantsStockModal
